import { inject, Injectable } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { ISideListOptionsItem } from '../fi-items-list/fi-items-list';
import { SideListOptionType } from '../types';
import { FiChecklist2Service } from './fi-checklist2.service';

@Injectable()
export class FiChecklist2SideListOptionsHelperService {
    private appTextService = inject(AppTextService);
    private fiChecklist2Service = inject(FiChecklist2Service);

    private readonly SharedWithMeOption: ISideListOptionsItem = {
        value: SideListOptionType.SharedWithMe,
        text: this.appTextService.get('common.shared_with_me'),
    };
    private readonly CurrentCheckListsOption: ISideListOptionsItem = {
        value: SideListOptionType.CurrentCheckLists,
        text: this.appTextService.get('checklist.current_checklists'),
    };
    private readonly NonCurrentChecklistsOption: ISideListOptionsItem = {
        value: SideListOptionType.NonCurrentChecklists,
        text: this.appTextService.get('checklist.non_current_checklists'),
    };
    private readonly OnDemandChecklistsOption: ISideListOptionsItem = {
        value: SideListOptionType.OnDemandChecklists,
        text: this.appTextService.get('checklist.on_demand'),
    };
    private readonly ExpiredOption: ISideListOptionsItem = {
        value: SideListOptionType.Expired,
        text: this.appTextService.get('checklist.expired_checklists'),
    };
    private readonly CreatedByOption: ISideListOptionsItem = {
        value: SideListOptionType.CreatedBy,
        text: this.appTextService.get('common.created_by_me'),
    };

    getChecklistSideListOptions(auditMode: boolean): ISideListOptionsItem[] {
        // "Created by me" and "Expired" are not allowed for "read" users
        if (this.fiChecklist2Service.isChecklistShareRights(auditMode)) {
            return [
                this.SharedWithMeOption,
                this.CreatedByOption,
                this.CurrentCheckListsOption,
                this.NonCurrentChecklistsOption,
                this.OnDemandChecklistsOption,
                this.ExpiredOption,
            ];
        }

        return [
            this.SharedWithMeOption,
            this.CurrentCheckListsOption,
            this.NonCurrentChecklistsOption,
            this.OnDemandChecklistsOption,
        ];
    }

    getChecklistTemplateSideListOptions(auditMode: boolean): ISideListOptionsItem[] {
        // "My checklist templates" is not allowed for "read" users
        if (this.fiChecklist2Service.isChecklistShareRights(auditMode)) {
            return [this.SharedWithMeOption, this.CreatedByOption];
        }

        return [this.SharedWithMeOption];
    }
}
